import { render, staticRenderFns } from "./SaveTheDate.vue?vue&type=template&id=4b9a4237&scoped=true"
import script from "./SaveTheDate.vue?vue&type=script&lang=js"
export * from "./SaveTheDate.vue?vue&type=script&lang=js"
import style0 from "./SaveTheDate.vue?vue&type=style&index=0&id=4b9a4237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a4237",
  null
  
)

export default component.exports